import IndustryChecklistI18n from "@/components/landing/shared/IndustryChecklistI18n";
const ChecklistSection = () => <IndustryChecklistI18n translationPrefix="industryMaschinenbau" />;
export default ChecklistSection;
